<template>
  <div class="boxBty">
     <div class="society-dynamic">
    <div class="title">
      <span class="iconLeft"></span>
      <h2>中物鉴智动态</h2>
      <span class="iconRight"></span>
    </div>

    <!-- 上排 3 张等高卡片 -->
    <div class="top-cards">
      <div class="card large-card" @click="toItemFn(item)" v-for="(item, idx) in topList" :key="idx">
        <div class="card-image-section">
          <img  :src="`${$baseUrl}/evaluation/api/attachment/preview/${item.coverImageId}`" alt=""  loading="lazy" class="card-image" />
        </div>
        <div class="card-content-section">
          <div class="title-line"></div>
          <h3 class="card-title">{{ item.title }}</h3>
          <p class="card-desc">{{ item.content }}</p>
          <div class="card-footer">
            <span class="date">{{ item.updateTime }}</span>
            <span class="arrow"><i class="el-icon-arrow-right"></i></span>
          </div>
        </div>
      </div>
    </div>

    <!-- 下排 轮播 -->
    <div class="swiper-container">
      <div class="nav-arrow left-arrow" @click="scrollPrev">
        <i class="el-icon-arrow-left"></i>
      </div>

      <div class="swiper-viewport">
        <div class="swiper-wrapper" :style="{ transform: `translateX(${translateX}px)` }">
          <div @click="toItemFn(item)" class="card small-card" style="padding: 10px;" v-for="(item, idx) in swiperList" :key="idx">
            <div class="card-content-section">
              <div class="title-line"></div>
              <h3 class="card-title">{{ item.title }}</h3>
              <p class="card-desc">{{ item.content }}</p>
              <div class="card-footer">
                <span class="date">{{ item.updateTime }}</span>
                <span class="arrow"><i class="el-icon-arrow-right"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="nav-arrow right-arrow" @click="scrollNext">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import {publishedPage} from '@/api/account';
export default {
  name: 'SocietyDynamic',
  data() {
    return {
      topList: [],
      swiperList: [],
      currentIndex: 0,
      itemWidth: 285,
      visibleCount: 4,
      cardGap: 20
    }
  },
  computed: {
    translateX() {
      return -this.currentIndex * (this.itemWidth + this.cardGap)
    }
  },
  created(){
      this.getList();
  },
  methods: {
    toItemFn(item){
        this.$router.push({
          path:'/index/notification/deils',
          query:{
            id:item.notifyId,
          }
        })
    },
    getList(){
       publishedPage({
        typeCode: 1,
        pageSize: 10000000,
        pageNumber: 1,
      }).then((res) => {
        if (res.code == 200) {
          let list = res.data?.pageRecords || [];
          this.swiperList = list.map(item => {
            return {
              ...item,
              content: this.extractText(item.content)
            };
          });
          this.topList = this.swiperList.slice(0, 3);
        }
      })
    },
     extractText(html) {
        if (!html) return '';
        let text = html.replace(/<img[^>]*>/g, '');
        text = text.replace(/<[^>]+>/g, '');
        text = text.replace(/\\["nrt]/g, '');
        text = text.trim().replace(/\s+/g, ' ');
        return text;
      },
    scrollPrev() {
      if (this.currentIndex > 0) this.currentIndex--
    },
    scrollNext() {
      const max = this.swiperList.length - this.visibleCount
      if (this.currentIndex < max) this.currentIndex++
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.society-dynamic {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
  font-family: "Microsoft YaHei", sans-serif;
}
.title {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
  position: relative;
}

.title h2 {
  font-weight: 800;
  font-size: 36px;
  color: #333;
  margin: 0 30px;
  white-space: nowrap;
}

.title::before,
.title::after {
  content: '';
  width: 100px;
  height: 2px;
  background-color: #0066cc;
}

.iconLeft,
.iconRight {
  display: none;
}
.top-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 30px;
}

.card {
  background: #fff;
  overflow: hidden;
  box-shadow: 0 1px 5px rgba(0,0,0,0.04);
  cursor: pointer; 
}

.large-card {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.card-image-section {
  width: 100%;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.card-image-section:hover .card-image {
  transform: scale(1.1);
}
.card-content-section {
  height: auto;
  min-height: 160px;
  padding: 20px;
  display: flex;
  flex-direction: column;
}
.title-line {
  width: 26px;
  height: 2px;
  background: #1890ff;
  margin-bottom: 10px;
  flex-shrink: 0;
  transition: width 0.4s ease; 
}
.card:hover .title-line {
  width: 52px;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  color: #000;
  line-height: 1.5;
  margin-bottom: 8px;
  flex-shrink: 0;
  height: 40px;
}

.card-desc {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
  overflow: hidden;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2; 
  -webkit-box-orient: vertical;
  word-break: break-all; 
}

.card-footer {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
  margin-top: 10px;
  flex-shrink: 0;
}

.arrow {
  color: #bbb;
}
.swiper-container {
  position: relative;
  width: 100%;
  margin: 0 auto;
}

.swiper-viewport {
  width: 100%;
  overflow: hidden;
}

.swiper-wrapper {
  display: flex;
  transition: transform 0.35s ease;
  gap: 20px;
}

.small-card {
  width: 280px;
  flex-shrink: 0;
}
.nav-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 99;
}

.left-arrow { left: 0px; }
.right-arrow { right: 0px; }
.nav-arrow i { font-size: 16px; color: #666; }

@media (min-width: 768px) {
  .title h2 {
    font-size: 32px;
  }
  .large-card {
    width: calc(50% - 10px);
  }
  .card-image-section {
    height: 240px;
  }
  .left-arrow { left: -20px; }
  .right-arrow { right: -20px; }
}

@media (min-width: 1024px) {
  .title h2 {
    font-size: 36px;
  }
  .large-card {
    width: calc(33.333% - 14px);
  }
  .card-image-section {
    height: 260px;
  }
  .left-arrow { left: -58px; }
  .right-arrow { right: -58px; }
}

@media (max-width: 767px) {
  .title {
    margin-bottom: 24px;
  }
  .title h2 {
    font-size: 24px;
    margin: 0 15px;
  }
  .title::before,
  .title::after {
    width: 20%;
    height: 2px;
  }
  .card-content-section {
    min-height: 140px;
    padding: 16px;
  }
  .card-image-section {
    height: 180px;
  }
  .nav-arrow {
    width: 32px;
    height: 32px;
  }
  .left-arrow { left: 4px; }
  .right-arrow { right: 4px; }
}
.boxBty{
  background: url('~@/assets/images/xw2.jpg');
  width: 100%;
  background-size: 100% 100%;
  background-position: 100%;
}
</style>